import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import type { Variable } from "@/domains/templates/types";
import type { TemplateInputFieldEditorData } from "@/domains/templates/components/template-input-fields/template-input-field-editor-row";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/shared/components/ui/collapsible";
import { TemplateVariableList } from "./template-variable-list";

type TemplateAnalysisVariablesSectionProps = {
  templateId: string;
  variables: Variable[];
  isReadOnly?: boolean;
  editorData: TemplateInputFieldEditorData;
};

export function TemplateAnalysisVariablesSection({
  templateId,
  variables,
  isReadOnly = false,
  editorData,
}: TemplateAnalysisVariablesSectionProps) {
  const [open, setOpen] = useState(false);

  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <section className="grid gap-3">
        <CollapsibleTrigger asChild>
          <button
            type="button"
            className="flex w-full items-center gap-2 rounded-md px-1 py-1 text-left hover:bg-muted/50"
          >
            {open ? (
              <ChevronDown className="h-4 w-4 shrink-0" />
            ) : (
              <ChevronRight className="h-4 w-4 shrink-0" />
            )}
            <span className="min-w-0">
              <span className="block text-base font-medium">
                Analysis Variables
              </span>
              <span className="block text-sm text-muted-foreground">
                Configure variables available at the template analysis level.
              </span>
            </span>
          </button>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <TemplateVariableList
            target={{ level: "analysis", templateId }}
            variables={variables}
            editorData={editorData}
            isReadOnly={isReadOnly}
            emptyText="No analysis-level variables configured."
          />
        </CollapsibleContent>
      </section>
    </Collapsible>
  );
}
